

class Symbols {
  constructor() {
    const symbols = document.querySelectorAll('span.symbol, .symbol > p > span');
    if(!!symbols){
      this.renderSymbols(symbols)
    }
    
    document.addEventListener('noteLoaded', () => {
      const symbols = document.querySelectorAll('span.symbol, .symbol > p > span');
      if(!!symbols){
        this.renderSymbols(symbols)
      }
    });

  }

  renderSymbols(symbols){
    symbols.forEach(sym => {
      sym.parentNode.style.textAlign = 'center';
      sym.classList.add(sym.innerText);
      if(!sym.classList.contains('symbol')){
        sym.classList.add('symbol');
      }
      sym.innerText = '';
    });

    const symbolT = document.querySelector('.symbol.t');

    if(!!symbolT){
      symbolT.appendChild('<svg width="78px" height="66px" viewBox="0 0 78 66" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Tabelle_mit_Statusanzeige" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(-936.000000, -619.000000)" id="Group-4" stroke="currentColor" stroke-width="10"><g transform="translate(35.000000, 272.000000)"><polyline id="Line" points="906.919922 388.691406 927.970703 407.833984 973.466797 352.488281"></polyline></g></g></g></svg>');
    }
    

  }


  /*function renderSymbols(){
    $('span.symbol, .symbol > p > span').each(function(){
      $(this).parent().css('text-align', 'center');
      $(this).addClass($(this).text());
      if(!$(this).hasClass('symbol')){
        $(this).addClass('symbol');
      }
      $(this).text('');
    });

    $('.symbol.t').append('<svg width="78px" height="66px" viewBox="0 0 78 66" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Tabelle_mit_Statusanzeige" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(-936.000000, -619.000000)" id="Group-4" stroke="currentColor" stroke-width="10"><g transform="translate(35.000000, 272.000000)"><polyline id="Line" points="906.919922 388.691406 927.970703 407.833984 973.466797 352.488281"></polyline></g></g></g></svg>');*/
}
export default Symbols;

